<script setup lang="ts">
import { Skeleton } from '@laam/ui/base';
</script>
<template>
	<div class="product_card relative flex flex-col h-[350px] w-full p-sm">
		<Skeleton class="w-full h-[220px] rounded-xxs" />
		<div class="absolute left-xs top-xs p-md">
			<Skeleton class="w-[44px] h-[20px]" color="dark" />
		</div>
		<div class="absolute right-md bottom-md p-md bg-white">
			<Skeleton class="w-[44px] h-[20px] rounded-full" color="dark" />
		</div>
		<div class="flex flex-col py-md gap-xs">
			<div class="flex justify-between items-start">
				<Skeleton class="w-[90px] h-[16px] rounded-full" color="dark" />
				<Skeleton class="w-[20px] h-[20px]" />
			</div>
			<Skeleton class="w-[60px] h-[16px] rounded-full" />
			<Skeleton class="w-full h-[12px] rounded-full" />
		</div>
	</div>
</template>
